import { checkIfUserIsLoggedIn } from '../utils/utils';

export function initDownloadLinkIfLoggedIn() : void {
    document.querySelectorAll<HTMLAnchorElement>('a[data-download-if-logged-in]').forEach($link => {
        new DownloadLinkIfLoggedIn($link);
    });
}

/**
 * Check if user is logged in before download a document
 * 
 * Usage:
 * <a href="{LINK_TO_DOWNLOAD_FILE}" data-download-if-logged-in="{FILENAME}">Download</a>
 */
class DownloadLinkIfLoggedIn {
    constructor($downloadLink: HTMLAnchorElement) {
        $downloadLink.addEventListener('click', evt => {
            evt.preventDefault();

            const $button = evt.target as HTMLAnchorElement;
            const filename = $button.dataset.downloadIfLoggedIn || '';
            const $loader = $button.querySelector<HTMLElement>('.loading');
            const $errorFileDownloadElement = document.querySelector<HTMLElement>('.error-file-download');

            $button.classList.add('wait');
            $loader?.classList.remove('hidden');

            checkIfUserIsLoggedIn().then(userIsLoggedIn => {
                if (!userIsLoggedIn) {
                    // Redirect to login page
                    window.location.href = scriptVar.loginUrl + '?referrer=' + window.location.href;
                    return;
                }

                fetch($button.getAttribute('href') || '')
                    .then(response => {
                        if (response.status !== 200) {
                            throw Error(response.statusText);
                        }

                        const resp = response;
                        return resp;
                    })
                    .then(resp => resp.blob())
                    .then(blob => {
                        $loader?.classList.add('hidden');
                        $button.classList.remove('wait');
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        $errorFileDownloadElement?.classList.add('hidden');
                    })
                    .catch(() => {
                        $errorFileDownloadElement?.classList.remove('hidden');
                        $loader?.classList.add('hidden');
                        $button.classList.remove('wait');
                    });
            });
        });
    }
}
